import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProjectsSection from './components/ProjectsSection';
import StartupSection from './components/StartupSection';
import FloatingLogosSection from './components/FloatingLogosSection';
import RealisationsSection from './components/RealisationsSection';
import CTASection from './components/CTASection';
import Offers from './components/Offers';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import ContactForm from './components/ContactForm';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import LegalNotice from './components/LegalNotice';
import SEO from './components/SEO';

// Page d'accueil principale
const HomePage = () => {
  return (
    <>
      <SEO 
        title="Créations digitales qui transforment votre entreprise" 
        description="Nous concevons des sites web et des expériences digitales qui captent l'attention, engagent vos utilisateurs et convertissent vos visiteurs en clients fidèles." 
        canonical="/#/"
      />
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <ProjectsSection />
        <StartupSection />
        <FloatingLogosSection />
        <RealisationsSection />
        <ContactSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
};

// Pages légales avec Header et Footer
const PrivacyPage = () => {
  return (
    <>
      <SEO 
        title="Politique de confidentialité" 
        description="Découvrez notre politique de confidentialité et comment nous protégeons vos données personnelles chez Aiko." 
        canonical="/#/confidentialite"
      />
      <Header />
      <PrivacyPolicy />
      <Footer />
    </>
  );
};

const LegalNoticePage = () => {
  return (
    <>
      <SEO 
        title="Mentions légales" 
        description="Consultez les mentions légales d'Aiko, informations sur l'entreprise, l'hébergement et les conditions d'utilisation du site." 
        canonical="/#/mentions-legales"
      />
      <Header />
      <LegalNotice />
      <Footer />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/confidentialite" element={<PrivacyPage />} />
            <Route path="/mentions-legales" element={<LegalNoticePage />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
